import React from "react";
import { FiEdit, FiZoomIn } from "react-icons/fi";
import Tooltip from "../tooltip/Tooltip";
import { Link } from "react-router-dom";
import {Button } from "@windmill/react-ui"
const EditDeleteButton = ({
  id,
  title,
  tab,
  handleModifyUpdate,
  handleModalOpen,days_count,
  isCheck,
  product,
  vendor_name,
  latest_va_id,
  vendor_id,
  end_date,
  start_date,
  parent,
  children,
  hideDelete, 
  package_type,
  is_vehicle_alloted,
  vendorAction,
  clientArrived,
  tripWentOrNot
}) => {

  return (
    <>
  {/* {  console.log(latest_va_id,vendor_id)} */}
      <div className="flex justify-end text-right">
        {children?.length > 0 ? (
          <>
            <Link
              to={`/categories/${parent?._id}`}
              className="p-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none"
            >
              <Tooltip
                id="view"
                Icon={FiZoomIn}
                title="View"
                bgColor="#10B981"
              />
            </Link>

            <button
              disabled={isCheck?.length > 0}
              onClick={() => handleModifyUpdate(id,package_type)}
              className="p-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none"
            >
              <Tooltip
                id="edit"
                Icon={FiEdit}
                title="Edit"
                bgColor="#10B981"
              />
            </button>
          </>
        ) : (
          <Button
            disabled={isCheck?.length > 0}
            onClick={() => handleModifyUpdate(id,start_date,end_date,vendor_name,vendor_id,days_count,latest_va_id,package_type,is_vehicle_alloted,vendorAction,clientArrived,tripWentOrNot)}
            className="p-2 cursor-pointer text-white-400 hover:bg-green focus:outline-none"
          >
            Modify
          </Button>
        )}
       
      </div>
    </>
  );
};

export default EditDeleteButton;
